import React, { useEffect, useMemo, useState } from "react";
import { Table, Input, Button, Dropdown, Menu, Typography, Tag } from "antd";
import { FaEdit } from "react-icons/fa";
import { DownOutlined } from "@ant-design/icons";
import { t } from "i18next";

const { Title } = Typography;
const { Search } = Input;

const AllDomain = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [domains, setDomains] = useState([]);
  const [filterText, setFilterText] = useState("");

  const user = JSON.parse(localStorage.getItem("admin"));

  const getAllDomains = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_APIURL}/admin/getalldomain`, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      const response = await res.json();
      if (response.status_code === 200) {
        setDomains(response.data.reverse());
      } else {
        setDomains([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllDomains();
  }, []);

  const filteredData = useMemo(() => {
    if (!filterText) return domains;
    return domains.filter((item) =>
      item.domain_name.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [filterText, domains]);

  const handleMenuClick = (record, { key }) => {
    console.log(`${key} clicked for domain:`, record);
    // Implement actual actions like Publish, Suspend, Delete, etc.
  };

  const columns = [
    {
      title: t("Domain Name"),
      dataIndex: "domain_name",
      key: "domain_name",
    },
    {
      title: t("Full Domain"),
      dataIndex: "full_domain_name",
      key: "full_domain_name",
    },
    {
      title: t("Store Id"),
      dataIndex: "store_id",
      key: "store_id",
    },
    {
      title: t("Status"),
      dataIndex: "is_active",
      key: "is_active",
      render: (is_active) => (
        <Tag color={is_active ? "green" : "orange"}>
          {is_active ? "Active" : "Pending"}
        </Tag>
      ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (created_at) => {
        const date = new Date(created_at);
        return date.toLocaleString("en-US", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    {
      title: t("Action"),
      key: "action",
      render: (_, record) => (
        <Dropdown
          overlay={
            <Menu onClick={(e) => handleMenuClick(record, e)}>
              <Menu.Item key="publish">{t("Publish")}</Menu.Item>
              <Menu.Item key="suspend">{t("Suspend")}</Menu.Item>
              <Menu.Item key="delete">{t("Move to trash")}</Menu.Item>
            </Menu>
          }
          trigger={["click"]}
        >
          <Button icon={<FaEdit />}>
            {t("Action")} <DownOutlined />
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      <Title level={3}>{t("All Domains")}</Title>

      <div className="mb-4" style={{ maxWidth: "100%", overflowX: "auto" }}>
        <Search
          placeholder={t("Filter by Domain name")}
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          enterButton
          allowClear
          style={{ minWidth: 250, maxWidth: 400 }}
        />
      </div>

      <Table
        rowKey="domain_id"
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: "max-content" }}
      />
    </>
  );
};

export default AllDomain;
